/**
 * percentage.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: "percent"})
export class PercentagePipe implements PipeTransform {

  public transform (
    value : number,
    digits : number = 2
  ) : string
  {
    const f : number = Math.pow(10, digits);
    return (Math.round(value * f * 100) / f).toString(10) + "%";
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/percentage.pipe.ts